module.exports = __webpack_public_path__ + "img/male8.fc6478d1.jpg";